<template>
  <div class="dropzone">
    <!-- Not displayed, just for Dropzone's `dictDefaultMessage` option -->
    <div id="dropzone-message" style="display: none">
      <span class="dropzone-title text-gray-800">Déposer le fichier dans cette zone ou cliquez pour sélectionner</span><br>
      <span class="dropzone-info text-sm">Taille maximum : 5Mo</span>
    </div>

    <input type="hidden" v-for="(key, index) in files" :key="index" :name="'attachments[' + index + ']'" :value="key" />
  </div>
</template>

<script>
import Dropzone from 'dropzone'
import 'dropzone/dist/dropzone.css'

import axios from 'axios'

Dropzone.autoDiscover = false

export default {
  data () {
    return {
      files: []
    }
  },
  mounted () {
    const that = this
    const vm = this

    let options = {
      url: '/',

      method: 'put',

      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending (file, xhr) {
        let _send = xhr.send
        xhr.send = () => {
          _send.call(xhr, file)
        }
      },

      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 1,
      uploadMultiple: false,
      maxFiles: 1,
      maxFilesize: 5,
      acceptedFiles: 'image/*,application/pdf',
      addRemoveLinks: true,

      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: '',

      // Customize the wording
      dictDefaultMessage: document.querySelector('#dropzone-message').innerHTML,
      dictCancelUpload: 'Annuler l\'envoi',
      dictRemoveFile: 'Supprimer',

      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,

      // Here we request a signed upload URL when a file being accepted
      accept (file, done) {
        //let fileExtension = file.name.split('.').pop();

        let payload = {
          filename: file.name,
          contentType: file.type
        }

        axios.post(process.env.VUE_APP_API_BASE_URL + 's3/get-signed', payload).then(({data}) => {
          file.uploadURL = data.signed_uri
          file.key = data.key

          done()
          setTimeout(() => vm.dropzone.processFile(file))
        }).catch((err) => {
          done('Failed to get an S3 signed upload URL', err)
        })

        /*
        lambda.getSignedURL(file)
          .then((url) => {
            file.uploadURL = url
            done()
            // Manually process each file
            setTimeout(() => vm.dropzone.processFile(file))
          })
          .catch((err) => {
            done('Failed to get an S3 signed upload URL', err)
          })
        */
      }
    }

    // Instantiate Dropzone
    this.dropzone = new Dropzone(this.$el, options)

    // Set signed upload URL for each file
    vm.dropzone.on('processing', (file) => {
      vm.dropzone.options.url = file.uploadURL
    })

    vm.dropzone.on('maxfilesexceeded', function(file) {
      vm.dropzone.removeFile(file);
    })

    vm.dropzone.on('success', function() {
      that.files = vm.dropzone.files.flatMap((el) => el.key)
      that.$emit('input', that.files[0]);
    })

    vm.dropzone.on('removedfile', function() {
      that.files = vm.dropzone.files.flatMap((el) => el.key)
    })
  }
}
</script>

<style>
  .dropzone {
    border-radius: 5px;
    border-width: 1px;
    border-color: inherit;
    background: inherit;
    background-color: inherit;
  }

  .dz-message {
    color: #a2a2a6;
  }

  .dropzone .dz-preview.dz-image-preview {
    background: none;
  }

  .dz-remove {
    margin-top: 8px;
    font-size: 12px;
    color: #6f100e;
  }
</style>